export default __webpack_public_path__ + "static/media/bgvideo.554a9b92.mp4";